import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Group } from '../../../../models/group.model';
import {
  MembershipStatus,
  MemberType,
} from '../../../../models/membership.status';
import { Prayer, PrayerStatus } from '../../../../models/prayer.model';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import * as prayerActions from '../../../../state/actions/prayer.actions';
import { AppState } from '../../../../state/appstate';
import * as groupSelector from '../../../../state/selectors/group.selector';
import * as prayerSelector from '../../../../state/selectors/prayer.selector';
import { BtnBackComponent } from '../../../components/buttons/btn-back/btn-back.component';
import { BtnPrayerStatusComponent } from '../../../components/buttons/btn-prayer-status/btn-prayer-status.component';
import { BtnRouteComponent } from '../../../components/buttons/btn-route/btn-route.component';
import { DlgSelectOptionComponent } from '../../../components/dialogs/dlg-select-option/dlg-select-option.component';
import { ChipComponent } from '../../../components/inputs/chip/chip.component';

@Component({
  selector: 'app-detail-prayer',
  standalone: true,
  templateUrl: './detail-prayer.component.html',
  imports: [
    AsyncPipe,
    BtnRouteComponent,
    BtnBackComponent,
    BtnPrayerStatusComponent,
    MatDialogModule,
    BtnBackComponent,
    MomentPipe,
    ChipComponent,
  ],
  styleUrls: ['./detail-prayer.component.css'],
})
export class DetailPrayerComponent implements OnInit, OnDestroy {
  route: ActivatedRoute = inject(ActivatedRoute);
  private dialog: MatDialog = inject(MatDialog);

  group: Group | null | undefined;
  groupSub: Subscription | undefined;

  prayerSub: Subscription | undefined;
  prayer: Prayer | null | undefined;

  groupId: string | null = null;
  prayerId: string | null = null;

  myRoles$: Observable<any> = new Observable();

  prayerStatus = PrayerStatus;
  membershipStatus = MembershipStatus;
  memberType = MemberType;

  constructor(
    private store: Store<AppState>,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._activatedRoute.paramMap.subscribe((params) => {
      this.groupId = params.get('id');
      this.prayerId = params.get('prayerId');
    });

    this.myRoles$ = this.store.select(
      groupSelector.getMyRolesInGroup(this.groupId),
    );
  }
  ngOnInit(): void {
    this.groupSub = this.store
      .pipe(select(groupSelector.getGroupById(this.groupId!)))
      .subscribe((group) => {
        this.group = group;
      });
    if (this.prayerId) {
      this.store.dispatch(prayerActions.getPrayer({ prayerId: this.prayerId }));
    }
    this.prayerSub = this.store
      .pipe(select(prayerSelector.getPrayerById(this.prayerId!)))
      .subscribe((prayer) => {
        this.prayer = prayer;
      });
  }

  ngOnDestroy(): void {
    this.groupSub?.unsubscribe();
    this.prayerSub?.unsubscribe();
  }

  changeStatusDialog() {
    let data: any = [];
    switch (this.prayer?.status) {
      case PrayerStatus.active:
        data = [PrayerStatus.active, PrayerStatus.closed];
        break;
      case PrayerStatus.closed:
        data = [PrayerStatus.closed, PrayerStatus.active];
        break;
      case PrayerStatus.request:
        data = [
          PrayerStatus.request,
          PrayerStatus.active,
          PrayerStatus.rejected,
        ];
        break;
      case PrayerStatus.rejected:
        data = [
          PrayerStatus.active,
          PrayerStatus.closed,
          PrayerStatus.rejected,
        ];
        break;
      default:
        data = [];
        break;
    }
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      title: 'Update Prayer Status',
      description: 'Select the new prayer status and proceed',
      options: data,
      action: 'Update',
      selectedOption: this.prayer?.status,
    };
    const dialogRef = this.dialog.open(DlgSelectOptionComponent, dialogConfig);

    return dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined && this.prayer) {
        return this.store.dispatch(
          prayerActions.updateStatus({
            id: this.prayer?.id!,
            prayer: {
              requestedBy: this.prayer.requestedBy,
              requestedById: this.prayer.requestedById,
              status: result,
            } as Prayer,
          }),
        );
      }
      return;
    });
  }
}
